import React, { useCallback } from 'react';
import moment from 'moment-timezone';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'antd';
import selector from '@store/changeLog/selectors';
import * as actions from '@store/changeLog/actions';
import { fmt } from './constants';
import DiffViewer from '../DiffViewer';
import * as filters from './filters';

const { Column } = Table;

interface ILog {
  id: number;
  description: string;
  username: string;
  createdAt: string;
}

interface IProps {
  logs: ILog[];
  type: string;
  loading?: boolean;
}

const renderCreatedAt = (time) => moment(time).format(fmt);
const renderViewDetail = () => <a>View Detail</a>;
const descriptionSorter = (a, b) => a.description.localeCompare(b.description);
const creatorSorter = (a, b) => a.username.localeCompare(b.username);
const timeSorter = (a, b) => (moment(a.createdAt).isAfter(moment(b.createdAt)) ? 1 : -1);

const ChangeLogTable: React.FC<IProps> = ({ logs, type, loading = false }) => {
  const dispatch = useDispatch();
  const { detail, showDetail } = useSelector(selector);
  const { description: title } = detail;
  let { before, after } = detail;
  /*eslint import/namespace: ['error', { allowComputed: true }]*/
  const filterFunc = filters[type];
  if (filterFunc) {
    before = filterFunc(before);
    after = filterFunc(after);
  }

  const onCancel = useCallback(() => {
    dispatch(actions.toggleDetail(false));
  }, [dispatch]);

  const onRow = useCallback(
    (record) => ({
      onClick: () => {
        dispatch(actions.fetchDetail(record.id));
      },
    }),
    [dispatch],
  );

  return (
    <>
      <Table
        dataSource={logs}
        onRow={onRow}
        loading={loading}
        bordered
        pagination={{ defaultPageSize: 15 }}
        rowKey="id"
      >
        <Column
          title="Description"
          dataIndex="description"
          key="description"
          sorter={descriptionSorter}
        />
        <Column title="Creator" dataIndex="username" key="username" sorter={creatorSorter} />
        <Column
          title="Time"
          dataIndex="createdAt"
          key="createdAt"
          render={renderCreatedAt}
          sorter={timeSorter}
        />
        <Column title="Actions" render={renderViewDetail} />
      </Table>
      <DiffViewer
        visible={showDetail}
        onCancel={onCancel}
        title={title}
        before={before}
        after={after}
      />
    </>
  );
};

export default ChangeLogTable;
